export const setCookie = function(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = function(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
} 
export default () => {
	const CookiePanel = (() => {
		"use strict";
	
		return function (basename, levels) {
		const COOKIE = "use-cookie";
		const LIFE = 90; //in days
		const VALUE = String(1);
		const LOCALSTORAGE = "use-localstorage";
		const NAME = (basename ? basename + "-" : "") + "privacy-settings";
		const PATH = "/";
		const DOMAIN = "";
	
		levels = levels || 1;
		let cookie_levels = [];
		for (let i = 0; i < levels; i++) {
			cookie_levels[i] = i + 1;
		}
		let _self = this;
		let cookie_mode = null;
	
		_self.getCookie = function (level) {
			switch (cookie_mode) {
			case COOKIE:
				let reg = new RegExp("(;)?" + NAME + level + "=([^;]*);?");
				let cookieValue = document.cookie.match(reg);
				if (cookieValue == null) {
				return undefined;
				} else {
				if (decodeURI(cookieValue[2]) != String(VALUE)) return undefined;
				else return decodeURI(cookieValue[2]);
				}
				break;
			case LOCALSTORAGE:
				let cookieObject = localStorage.getItem(NAME + level);
				if (cookieObject) {
				let data = JSON.parse(cookieObject);
				if (data.expires) {
					let date = new Date(data.expires);
					var now = new Date();
					if (date < now) {
					_self.setCookie(level, null);
					return undefined;
					}
				}
				if (data.cookieSettings) {
					return data.cookieSettings;
				} else {
					return undefined;
				}
				} else {
				return undefined;
				}
				break;
			}
		};
	
		_self.setCookie = function (level) {
			switch (cookie_mode) {
			case COOKIE:
				let cookieDate = new Date();
				cookieDate.setDate(cookieDate.getDate() + parseInt(LIFE));
				let cValue =
				encodeURI(VALUE) +
				"; expires=" +
				cookieDate.toUTCString() +
				";path=" +
				PATH +
				";" +
				"domain=" +
				DOMAIN +
				";";
				document.cookie = NAME + level + "=" + cValue;
				_self.dispatchCookieEvent(level);
				break;
			case LOCALSTORAGE:
				let lcDate = new Date();
				lcDate.setDate(lcDate.getDate() + parseInt(LIFE));
				var data = { cookieSettings: VALUE, expires: lcDate.toString() };
				localStorage.setItem(NAME + level, JSON.stringify(data));
				_self.dispatchCookieEvent(level);
				break;
			}
		};
	
		_self.removeCookie = function (level) {
			switch (cookie_mode) {
			case COOKIE:
				let cValue =
				"; expires=" +
				"Thu, 01 Jan 1970 00:00:01" +
				";path=" +
				PATH +
				";" +
				"domain=" +
				DOMAIN +
				";";
				document.cookie = NAME + level + "=" + cValue;
	
				break;
			case LOCALSTORAGE:
				localStorage.removeItem(NAME + level);
				break;
			}
		};
	
		_self.dispatchCookieEvent = function (level) {
			//if (window["dataLayer"] && window["dataLayer"]["push"]) {
			cookie_levels.forEach((el, i) => {
			if (!level || el == level) {
				let _value = _self.getCookie(el);
				if (_value) {
				/*dataLayer.push({
								event: "privacy-"(el),
							});*/
				}
			}
			});
			/*} else {
				console.log("missing data layer");
			}*/
		};
	
		let init = () => {
			let cookieEnabled = navigator.cookieEnabled ? true : false;
			if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
			document.cookie = "testcookie";
			cookieEnabled =
				document.cookie.indexOf("testcookie") != -1 ? true : false;
			}
			if (cookieEnabled) {
			cookie_mode = COOKIE;
			} else if (typeof Storage !== "undefined") {
			cookie_mode = LOCALSTORAGE;
			}
	
			var event = new CustomEvent(CookiePanel.COOKIE_READY, {});
			document.dispatchEvent(event);
			if (cookie_mode) _self.dispatchCookieEvent();
		};
		init();
		};
	})();

	CookiePanel.COOKIE_READY = "cookie_ready";
	window.CookiePanel = CookiePanel;

	let cookiePanel = new CookiePanel('FIDL', 1);
	let panel = document.getElementById('privacy-popup');
		
	if(panel){
		panel.classList.add('active');
		panel.querySelector('button').addEventListener('click', e => {
			cookiePanel.setCookie(1);
			if(cookiePanel.getCookie(1)){
				panel.classList.remove('active');
			}
		}); 
		
		if(cookiePanel.getCookie(1)){
			panel.classList.remove('active');
		}
	}

}